export const failureHash = {
    DESCHEDULE_FORBIDDEN: "API__SMP__STREAM__DESCHEDULE_FORBIDDEN",
    DESTINATION_ALREADY_EXISTS: "API__SMP__STREAM__DESTINATION_ALREADY_EXISTS",
    DESTINATION_NAME_ALREADY_EXISTS: "API__SMP__STREAM__DESTINATION_NAME_ALREADY_EXISTS",
    DESTINATION_NOT_SPECIFIED: "API__SMP__STREAM__DESTINATION_NOT_SPECIFIED",
    DESTINATION_TWICE_SPECIFIED: "API__SMP__STREAM__DESTINATION_TWICE_SPECIFIED",
    DESTINATION_URL_NOT_VALID_RTMP: "API__SMP__STREAM__DESTINATION_URL_NOT_VALID",
    INSUFFICIENT_RESOURCES: "API__SMP__STREAM__INSUFFICIENT_RESOURCES",
    LIMIT_HIT_AIR_TIME: "API__SMP__STREAM__LIMIT_HIT_AIR_TIME",
    LIMIT_HIT_LIVE_STREAMS_CONFIGURED: "API__SMP__STREAM__LIMIT_HIT_LIVE_STREAMS_CONFIGURED",
    LIVE_STREAM_SOURCE_NOT_SUPPORTED: "API__SMP__STREAM__LIVE_STREAM_SOURCE_NOT_SUPPORTED",
    OBJECT_NOT_FOUND: "API__SMP__STREAM__OBJECT_NOT_FOUND",
    SCHEDULE_FORBIDDEN: "API__SMP__STREAM__SCHEDULE_FORBIDDEN",
    SOURCE_ORIGIN_INVALID: "API__SMP__STREAM__SOURCE_ORIGIN_INVALID",
    SOURCE_POSITION_ALREADY_EXISTS: "API__SMP__STREAM__SOURCE_POSITION_ALREADY_EXISTS",
    STREAM_FORBIDDEN: "API__SMP__STREAM__STREAM_FORBIDDEN",
    STREAM_NAME_ALREADY_EXISTS: "API__SMP__STREAM__STREAM_NAME_ALREADY_EXISTS",
    STREAM_START_TOO_CLOSE: "API__SMP__STREAM__STREAM_START_TOO_CLOSE",
};
//# sourceMappingURL=stream.static.js.map